import styled from 'styled-components';
import Colors from 'library/constants/colors';

// eslint-disable-next-line import/prefer-default-export
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background: rgba(${Colors.shade01Rgb}, 0.4);
  z-index: ${({ isGlobal }) => (isGlobal ? 22 : 20)};
  pointer-events: ${({ isClickable }) => (isClickable ? 'auto' : 'none')};
  
  :hover + ~:hover {
    pointer-events: none;
  }
`;
